exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._2ZkCWWw9Moyp86-o4XNO7K{font-family:\"aktiv-grotesk\",\"Aktiv Grotesk\",\"Open Sans\",\"Gill Sans MT\",\"Gill Sans\",Corbel,Arial,sans-serif;max-width:600px;margin:0 auto;text-align:center;color:#666;font-size:14px}._2ZkCWWw9Moyp86-o4XNO7K p{line-height:1.5}._1YlAVxt2EiEFn2BFdWctV-{margin-top:60px}._1YlAVxt2EiEFn2BFdWctV- i{display:inline-block;margin:0 10px}\n", ""]);

// Exports
exports.locals = {
	"infoMessage": "_2ZkCWWw9Moyp86-o4XNO7K",
	"multibike": "_1YlAVxt2EiEFn2BFdWctV-"
};